import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const UserLocationRoutes = defineRoute({
    home: {
        route: {
            path: "/user-location",
            component: () => loadView(import("./UserLocationHome.vue")),
        },
    },
});
